import { axios } from '@Root/API'

export const getPersons = params => {
	return axios.get('people', {
		params,
	})
}
